// import {
//   POSITIONS_CREATE_ACTIONS,
//   POSITIONS_LIST_ACTIONS,
//   POSITIONS_EDIT_ACTIONS,
//   POSITIONS_DELETE_ACTIONS,
// } from "../../../actionsType";
// import { ADMIN_POSITIONS_ACTIONS } from "../../../actionsType/admin/positions";

import { ADMIN_POSITIONS_ACTIONS } from "../../../actionType/admin/position";

const intialState = {
  positionsCreatData: {},
  isPositionsCreatLoader: false,
  positionsList: [],
  isPositionsListLoader: false,
  positionsDeleteLoader: false,
  positionsDeleteData: {},
};

export const adminPositionReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_REQUEST:
      return { ...state, isPositionsCreatLoader: true };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_RESPONSE:
      return {
        ...state,
        positionsCreatData: payload,
        isPositionsCreatLoader: false,
      };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_ERROR:
      return {
        ...state,
        positionsCreatData: payload,
        isPositionsCreatLoader: false,
      };

    // POSITIONS_LIST_ACTIONS

    case ADMIN_POSITIONS_ACTIONS.POSITIONS_LIST_REQUEST:
      return { ...state, isPositionsListLoader: true };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_RESPONSE:
      return {
        ...state,
        positionsList: payload,
        isPositionsListLoader: false,
      };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_LIST_RESPONSE:
      return {
        ...state,
        positionsList: payload,
        isPositionsListLoader: false,
      };

    // POSITIONS_EDIT_ACTIONS

    case ADMIN_POSITIONS_ACTIONS.POSITIONS_EDIT_REQUEST:
      return { ...state, isPositionsCreatLoader: true };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_EDIT_RESPONSE:
      return {
        ...state,
        positionsCreatData: payload,
        isPositionsCreatLoader: false,
      };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_EDIT_ERROR:
      return {
        ...state,
        positionsCreatData: payload,
        isPositionsCreatLoader: false,
      };
    // POSITIONS_DELETE_ACTIONS

    case ADMIN_POSITIONS_ACTIONS.POSITIONS_DELETE_REQUEST:
      return { ...state, positionsDeleteLoader: true };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_DELETE_REQUEST:
      return {
        ...state,
        positionsDeleteData: payload,
        positionsDeleteLoader: false,
      };
    case ADMIN_POSITIONS_ACTIONS.POSITIONS_DELETE_ERROR:
      return {
        ...state,
        positionsDeleteData: payload,
        positionsDeleteLoader: false,
      };
    default:
      return state;
  }
};
